import { isNumber } from 'utils/validators';
import moment from 'moment';

const validate = values => {
  const errors = {};

  if (isNumber(values.accommodation, true)) {
    errors.accommodation = 'Accommodation is required';
  }

  if (!values.dates || !values.dates.startDate || !values.dates.endDate) {
    errors.dates = 'Dates are required';
  } else if (
    moment(values.dates.endDate).diff(values.dates.startDate, 'days') <
    values.minNights
  ) {
    errors.dates = {
      text: 'The number of nights cannot be less than',
      variables: { number: values.minNights }
    };
  }

  if (values.participants && values.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    values.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one category should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    values.participants &&
    values.participants.length
  ) {
    const availableParticipants = values.startTime
      ? values.startTime.seatsLeft
      : values.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    values.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t exceed ${availableParticipants}`
      };
    }
  }

  return errors;
};

export default validate;
